import React from 'react';
import styles from './PromotionsFilter.module.css';

interface PromotionsFilterProps {
  activeFilter: string | null;
  onToggle: (filter: string) => void;
}

const filters = ['Type', 'Status', 'Tier'];

export const PromotionsFilter: React.FC<PromotionsFilterProps> = ({ activeFilter, onToggle }) => {
  return (
    <div className={styles.filters}>
      {filters.map((f) => (
        <button
          key={f}
          className={`${styles.filterBtn} ${activeFilter === f ? styles.filterActive : ''}`}
          onClick={() => onToggle(f)}
        >
          {f}
        </button>
      ))}
    </div>
  );
};
